import { render, staticRenderFns } from "./CreateDocumentCompany.vue?vue&type=template&id=482a6f49&scoped=true&"
import script from "./CreateDocumentCompany.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentCompany.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocumentCompany.vue?vue&type=style&index=0&id=482a6f49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a6f49",
  null
  
)

export default component.exports